import { render, staticRenderFns } from "./AddResume.vue?vue&type=template&id=68a13550&"
import script from "./AddResume.vue?vue&type=script&lang=js&"
export * from "./AddResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports